import { RoleHierarchy } from '../../../../shared/src/data/roleHierarchy/roleHierarchy'
import {
  Box,
  Button,
  CircularProgress,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import { RoleHierarchySelector } from '../../admin/roleHierarchySelector'
import React from 'react'
import { useRoleHierarchyManager } from '../../admin/queries/roleHierarchyManagement'
import { Alert, AlertTitle } from '@material-ui/lab'

export type SelectRoleHierarchyForScanExecutionProps = {
  selectedRoleHierarchy?: RoleHierarchy
  setSelectedRoleHierarchy: (roleHierarchy?: RoleHierarchy) => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alertContainer: {
      width: '100%',
    },
    loading: {
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  }),
)

export function SelectRoleHierarchyForScanExecution({
  selectedRoleHierarchy,
  setSelectedRoleHierarchy,
}: SelectRoleHierarchyForScanExecutionProps): JSX.Element {
  const {
    getRoleHierarchiesQuery: { data, isLoading, error, refetch },
  } = useRoleHierarchyManager()
  const classes = useStyles()

  return (
    <Box>
      {isLoading ? (
        <CircularProgress className={classes.loading} color='secondary' />
      ) : error ? (
        <Alert
          severity='error'
          className={classes.alertContainer}
          action={
            <Button
              variant='contained'
              color='secondary'
              onClick={() => refetch()}
            >
              RETRY
            </Button>
          }
        >
          <AlertTitle>
            <Typography variant='h6'>Failed to get role hierarchies</Typography>
          </AlertTitle>
          <Typography variant='subtitle1'>
            Unable to get role hierarchies: "
            {(error as Error) ? (error as Error).message : 'Unknown error'}"
          </Typography>
        </Alert>
      ) : (
        <RoleHierarchySelector
          roleHierarchies={data || []}
          selectedRoleHierarchy={selectedRoleHierarchy}
          setSelectedRoleHierarchy={setSelectedRoleHierarchy}
        />
      )}
    </Box>
  )
}
